import { CONTACT } from "@/data/content";

export default function BrochureViewer() {
  return (
    <div className="fixed inset-0 bg-[#1a1a1a]" data-testid="brochure-viewer">
      <object
        data={CONTACT.brochure}
        type="application/pdf"
        className="w-full h-full"
        aria-label="Krystal Technology Brochure"
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-white text-center px-6">
          <p className="text-base">Preparing the brochure…</p>
          <a
            href={CONTACT.brochure}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-black px-5 py-3 text-sm font-medium uppercase tracking-wide"
          >
            Open Brochure
          </a>
        </div>
      </object>
    </div>
  );
}
